<template>
    <v-card :loading="loading" mx-4 min-height="500">
        <template slot="progress">
            <v-overlay absolute class="d-flex flex-column text-center">
                <div>
                    <v-progress-circular size="250" width="10" color="primary" indeterminate>
                        <span>In curs de incarcare...</span>
                    </v-progress-circular>
                </div>
            </v-overlay>
        </template>
        <v-card-title>
            <v-layout row wrap>
                <v-col cols="6">
                    {{ title }}
                </v-col>
                <v-col cols="6" class="text-right">
                </v-col>
                <v-col md="9" sm="12">
                    <period-selector v-model="period" :button-class="['mt-3']"></period-selector>
                </v-col>
                <v-col md="3" sm="12" class="text-right">
                    <v-select
                        v-model="type"
                        :items="productTypes"
                        label="Tip produs"
                        item-value="id"
                        item-text="text"
                        hide-details
                        clearable
                    ></v-select>
                </v-col>
            </v-layout>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.name="{ item }">
                {{ _.get(item, 'product.name') }}
            </template>
            <template v-slot:item.product_number="{ item }">
                {{ _.get(item, 'product.product_number') }}
            </template>
            <template v-slot:item.quantity="{ item }">
                {{ _.get(item, 'quantity') | number }}
            </template>
            <template v-slot:item.measurement="{ item }">
                {{ _.get(item, 'measurement') }}
            </template>
            <template v-slot:item.unit_price="{ item }">
                {{ _.get(item, 'unit_price') | price }}
            </template>
            <template v-slot:item.entry_amount="{ item }">
                {{ _.get(item, 'entry_amount') | price }}
            </template>
            <template v-slot:item.delivery_time="{ item }">
                {{ _.get(item, 'delivery_time') }}
            </template>
            <template v-slot:item.customer="{ item }">
                {{ _.get(item, 'offer.customer.name') }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | date }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="viewItem(item)"
                >
                    mdi-eye
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import PeriodSelector from "Components/common/PeriodSelector";
    import SmartTable from "Components/SmartTable";
    export default {
        extends: SmartTable,
        components: {
            PeriodSelector
        },
        data: () => ({
            title: 'Raport produse ofertate',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Denumire', value: 'name' },
                { text: 'Cod produs', value: 'product_number' },
                { text: 'Cantitate', value: 'quantity' },
                { text: 'UM', value: 'measurement' },
                { text: 'Pret ofertat', value: 'unit_price' },
                { text: 'Pret Achiz', value: 'entry_amount' },
                { text: 'Termen de livrare', value: 'delivery_time' },
                { text: 'Client', value: 'customer' },
                { text: 'Data', value: 'created_at' },
                { text: 'Actiuni', value: 'actions' }
            ],
            options: {
                sortBy: ['created_at'],
                sortDesc: [true]
            },
            items: [],
            editedIndex: -1,
            showTrashed: false,
            productTypes: [],
            period: [window.moment().subtract(1, 'month').toISOString(), window.moment().toISOString()],
            type: null
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
        },

        watch: {
            showTrashed: {
                handler(val) {
                    this.initialize()
                }
            },
            period: {
                async handler(val) {
                    await this.initialize()
                }
            },
            type: {
                async handler(val) {
                    await this.initialize()
                }
            },
        },

        async created () {
            await this.initialize()
            this.productTypes = (new this.$db.Product).productTypes
        },

        methods: {
            async initialize () {
                this.loading = true
                var query = this.$db.OfferProduct
                    .include('product', 'offer.customer')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                if(this.type) query = query.where('type', this.type)
                if(this.showTrashed) query = query.where('onlyTrashed', true)
                if(this.period instanceof Array && this.period.length === 2) {
                    query = query.where('between', [window.moment(this.period[0]).format('YYYY-MM-DD'), window.moment(this.period[1]).format('YYYY-MM-DD')].join(','))
                }
                let { data, meta } = await query.get()
                this.items = data
                this.meta = meta
                this.loading = false
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            viewItem(item) {
                this.$router.push({ name: 'offers-edit', params: { id: item.offer_id } })
            }
        },
    };
</script>
